/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolBookmarkIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-bookmark"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 18.65L7.95 20.38Q6.63 20.95 5.44 20.16Q4.25 19.38 4.25 17.95L4.25 4.75Q4.25 3.65 5.03 2.88Q5.8 2.1 6.9 2.1L17.1 2.1Q18.2 2.1 18.98 2.88Q19.75 3.65 19.75 4.75L19.75 17.95Q19.75 19.38 18.56 20.16Q17.38 20.95 16.05 20.38Z" fill={color} />
    </svg>
  );
}
